import { FC } from 'react';
import { Card, Text } from '@mofid-securities/uikit';
import { useGetFundLandingData } from '../hooks/useGetFundLandingData';

export const Description: FC = () => {
  const { fundLandingData } = useGetFundLandingData();

  const { title, description } = fundLandingData || {};

  return description && title ? (
    <Card
      className="border-1 border border-gray-solid-primary-enabled"
      padding={16}
      radius="md"
    >
      <Text
        className="mb-2 text-gray-filled-primary-enabled"
        component="h2"
        size="sm"
        weight="demibold"
      >
        {title}
      </Text>
      <Text
        className="whitespace-pre-wrap font-sans text-gray-filled-primary-enabled"
        component="pre"
        size="xs"
        weight="medium"
      >
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </Text>
    </Card>
  ) : null;
};
